import { render, staticRenderFns } from "./DnsRecord.vue?vue&type=template&id=1d43d2c8&"
import script from "./DnsRecord.vue?vue&type=script&lang=js&"
export * from "./DnsRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports